export { default as dynamicFormValidateDocument } from './dynamicFormValidateDocument';

export type {
  DynamicFormValidateDocumentFunction,
  DynamicFormValidateDocumentPayload,
} from './dynamicFormValidateDocument.type';
